module.exports = __webpack_public_path__ + "img/021.c15f917d.png";